export const LIST_ADDITIONAL_SERVICE_REQUEST = 'LIST_ADDITIONAL_SERVICE_REQUEST'
export const LIST_ADDITIONAL_SERVICE_SUCCESS = 'LIST_ADDITIONAL_SERVICE_SUCCESS'
export const LIST_ADDITIONAL_SERVICE_FAIL = 'LIST_ADDITIONAL_SERVICE_FAIL'

export const LIST_ADDITIONAL_SERVICE_SUMMARY_REQUEST = 'LIST_ADDITIONAL_SERVICE_SUMMARY_REQUEST'
export const LIST_ADDITIONAL_SERVICE_SUMMARY_SUCCESS = 'LIST_ADDITIONAL_SERVICE_SUMMARY_SUCCESS'
export const LIST_ADDITIONAL_SERVICE_SUMMARY_FAIL = 'LIST_ADDITIONAL_SERVICE_SUMMARY_FAIL'

export const SELECT_SERVICE_ADDITIONAL_SERVICE_REQUEST = 'SELECT_SERVICE_ADDITIONAL_SERVICE_REQUEST'
export const SELECT_SERVICE_ADDITIONAL_SERVICE_SUCCESS = 'SELECT_SERVICE_ADDITIONAL_SERVICE_SUCCESS'
export const SELECT_SERVICE_ADDITIONAL_SERVICE_FAIL = 'SELECT_SERVICE_ADDITIONAL_SERVICE_FAIL'

export const SET_PRICE_ADDITIONAL_SERVICE_REQUEST = 'SET_PRICE_ADDITIONAL_SERVICE_REQUEST'
export const SET_PRICE_ADDITIONAL_SERVICE_SUCCESS = 'SET_PRICE_ADDITIONAL_SERVICE_SUCCESS'
export const SET_PRICE_ADDITIONAL_SERVICE_FAIL = 'SET_PRICE_ADDITIONAL_SERVICE_FAIL'

export const GET_ADDITIONAL_SERVICE_REQUEST = 'GET_ADDITIONAL_SERVICE_REQUEST'
export const GET_ADDITIONAL_SERVICE_SUCCESS = 'GET_ADDITIONAL_SERVICE_SUCCESS'
export const GET_ADDITIONAL_SERVICE_FAIL = 'GET_ADDITIONAL_SERVICE_FAIL'

export const GET_ADDITIONAL_SERVICE_REQUEST_BY_ID_REQUEST = 'GET_ADDITIONAL_SERVICE_REQUEST_BY_ID_REQUEST'
export const GET_ADDITIONAL_SERVICE_REQUEST_BY_ID_SUCCESS = 'GET_ADDITIONAL_SERVICE_REQUEST_BY_ID_SUCCESS'
export const GET_ADDITIONAL_SERVICE_REQUEST_BY_ID_FAIL = 'GET_ADDITIONAL_SERVICE_REQUEST_BY_ID_FAIL'

export const DELETE_ADDITIONAL_SERVICE_REQUEST = 'DELETE_ADDITIONAL_SERVICE_REQUEST'
export const DELETE_ADDITIONAL_SERVICE_SUCCESS = 'DELETE_ADDITIONAL_SERVICE_SUCCESS'
export const DELETE_ADDITIONAL_SERVICE_FAIL = 'DELETE_ADDITIONAL_SERVICE_FAIL'

export const RESET_ADDITIONAL_SERVICE = 'RESET_ADDITIONAL_SERVICE'

export const LIST_PARTNER_ADDITIONAL_SERVICE_REQUEST = 'LIST_PARTNER_ADDITIONAL_SERVICE_REQUEST'
export const LIST_PARTNER_ADDITIONAL_SERVICE_SUCCESS = 'LIST_PARTNER_ADDITIONAL_SERVICE_SUCCESS'
export const LIST_PARTNER_ADDITIONAL_SERVICE_FAIL = 'LIST_PARTNER_ADDITIONAL_SERVICE_FAIL'

export const GET_ADDITIONAL_SERVICE_SUPPORTING_DOCS_REQUEST = 'GET_ADDITIONAL_SERVICE_SUPPORTING_DOCS_REQUEST'
export const GET_ADDITIONAL_SERVICE_SUPPORTING_DOCS_SUCCESS = 'GET_ADDITIONAL_SERVICE_SUPPORTING_DOCS_SUCCESS'
export const GET_ADDITIONAL_SERVICE_SUPPORTING_DOCS_FAIL = 'GET_ADDITIONAL_SERVICE_SUPPORTING_DOCS_FAIL'